import * as React from "react";

function Cuboid(props) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 283.093 283.093"
      style="enable-background:new 0 0 283.093 283.093;"
      width={15}
      height={15}
      {...props}
    >
      <g>
        <path
          d="M271.315,54.522L218.989,2.196c-2.93-2.928-7.678-2.928-10.607,0L78.274,132.303c-1.049,1.05-1.764,2.388-2.053,3.843
		l-12.964,65.29c-0.487,2.456,0.282,4.994,2.053,6.765c1.421,1.42,3.334,2.196,5.304,2.196c0.485,0,0.975-0.047,1.461-0.144
		l65.29-12.964c1.456-0.289,2.793-1.004,3.843-2.053L271.315,65.129C274.244,62.2,274.244,57.452,271.315,54.522z M83.182,178.114
		l6.776-34.127l39.566,39.566l-34.127,6.776L83.182,178.114z"
        />
        <path
          d="M205.912,227.066c-71.729-30.029-118.425,19.633-132.371,27.175c-17.827,9.641-42.941,20.97-48.779,1.358
		c-3.522-11.832,15.521-24.479,28.131-28.42c9.2-2.876,5.271-17.358-3.988-14.465c-19.582,6.121-42.948,22.616-38.851,45.839
		c3.044,17.256,24.67,32.995,66.368,11.114c30.308-15.902,50.897-48.84,114.733-31.783c20.969,5.602,37.92,19.27,45.178,40.057
		c3.168,9.07,17.662,5.169,14.465-3.988C243.062,251.799,227.411,236.067,205.912,227.066z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Cuboid;
